<script lang="ts">
    import { onDestroy } from "svelte";
    import ajax from "../../ajax/ajax";
    import getProjectStore from "../../stores/ProjectStore";
    import MainMenu from "../menu/MainMenu.svelte";
    import type { TDirectoryTree } from "./TDirectoryTree";
    import TreeItem from "./TreeItem.svelte";
    export let projectId: number;
    const projectStore = getProjectStore(projectId);
    let tree: TDirectoryTree | undefined;
    let open: string[] = [];
    const unsubscribe = projectStore.subscribe((value) => {
        tree = value.tree;
        open = value.state.open;
    });
    onDestroy(() => {
        projectStore.destroy();
        unsubscribe();
    });
    ajax.get(
        `/projects/${projectId}/tree`,
        (data: { tree: TDirectoryTree }) => {
            projectStore.replaceTree(data.tree);
        },
        () => {}
    );
</script>

{#if tree}
    <div class="TreeContainer">
        <MainMenu />
        <ul class="Tree">
            <TreeItem {tree} {projectId} parentPath="" {open} />
        </ul>
    </div>
{/if}

<style type="text/scss">
    @import "../../scss/config.scss";
    .TreeContainer {
        background: $color-light-grey;
        padding: 10px;
        height: 100%;
        max-height: 100vh;
        box-sizing: border-box;
        overflow: auto;
        -webkit-overflow-scrolling: touch;
        -ms-overflow-style: -ms-autohiding-scrollbar;
        padding-top: 30px;
        &::-webkit-scrollbar {
            width: 4px;
        }

        &::-webkit-scrollbar-track {
            background: #ffffff25;
        }

        &::-webkit-scrollbar-thumb {
            width: 4px;
            background: rgba(0, 0, 0, 0.2);
            border-radius: 4px;
        }

        &::-webkit-scrollbar-thumb:hover {
            background: rgba(0, 0, 0, 0.5);
        }
    }
    .Tree {
        list-style: none;
        padding: 0;
    }
</style>
